import React, {useState, useEffect} from "react";
import {functions} from "../constants/common-functions";

import {DEFAULT_BLUE_GRADIENT} from "../constants/styles";
import { OMNISCAN_BLUE_SOFT } from "../constants/colors";

export default function FilterPanelBox(
{
    id,
    title,
    optionsUrl,
    filterBean,
    filterType,
    excludeType,
    onChange
})
{
	
    const [options, setOptions] = useState([]);
		
	useEffect(
	    function()
	    {
	        if(optionsUrl)
	        {
	            functions.getArrayFromAjax(
	                optionsUrl,
	                setOptions
	            );
	        }
	    },
	    [optionsUrl]
	);
	
	
    const [selectedValue, setSelectedValue] =
        useState("0");

		const thisContainer = {

		    display: "flex",

		    minWidth: "320px",

		    height: "calc(100% - 20px)",

		    marginRight: "16px",

		    flexDirection: "column",

		    borderRadius: "5px",

		    background:
		        "linear-gradient(180deg, " +
		        "rgba(24, 31, 40, 0.65) 0%, " +
		        "rgba(10, 17, 25, 0.72) 100%)",

		    border:
		        "1px solid rgba(141, 200, 240, 0.12)",

		    boxShadow:
		        "0 3px 12px rgba(0, 0, 0, 0.16)",

		    overflow: "hidden"

		};

    const header =
    {
        display: "flex",

        height: "34px",

        justifyContent: "space-between",

        alignItems: "center",

        padding: "0 10px",

        borderBottom:
            "1px solid rgba(255,255,255,0.06)"
    };

    const headerTitle =
    {
        color: "#e5e7eb",

        fontSize: "12px",

        fontWeight: "600",

        letterSpacing: "0.3px"
    };

	const optionPanel = {

	    display: "flex",

	    width: "100%",

	    height: "calc(100% - 34px)",

	    flexDirection: "column",

	    overflowY: "auto",
	    overflowX: "hidden",

	    scrollbarWidth: "thin",

	    scrollbarColor:
	        "rgba(110, 128, 145, 0.55) rgba(0, 0, 0, 0.18)"

	};

    const optionRow =
    {
        display: "flex",

        alignItems: "center",

        minHeight: "28px",

        padding: "0 10px",

        borderBottom:
            "1px solid rgba(255,255,255,0.03)"
    };

    const optionCheck =
    {
        marginRight: "8px",

        width: "14px",

        height: "14px",

        accentColor: OMNISCAN_BLUE_SOFT
    };

    const optionText =
    {
        display: "flex",

        fontSize: "12px",

        color: "#d1d5db"
    };

    const toggleContainer =
    {
        display: "flex",

        background:
            "rgba(255,255,255,0.05)",

        borderRadius: "6px",

        padding: "2px"
    };

    const toggleButton =
        function(active)
    {
        return {

            padding: "2px 8px",

            fontSize: "11px",

            borderRadius: "4px",

            cursor: "pointer",

			background:
			    active
			        ? OMNISCAN_BLUE_SOFT
			        : "transparent",

			color:
			    active
			        ? "#101820"
			        : "#9ca3af",

            transition:
                "all 0.2s ease"
        };
    };

    const includeIds =
        filterBean &&
        filterBean[filterType]
            ? filterBean[filterType]
            : [];

    const excludeIds =
        filterBean &&
        filterBean[excludeType]
            ? filterBean[excludeType]
            : [];

			const handleOptionChangeInclude =
			    function(e)
			{
			    const itemId =
			        parseInt(e.target.id);

			    let newIds =
			        [...includeIds];

			    if(e.target.checked)
			    {
			        if(!newIds.includes(itemId))
			        {
			            newIds.push(itemId);
			        }
			    }
			    else
			    {
			        newIds =
			            newIds.filter(
			                function(id)
			                {
			                    return id !== itemId;
			                }
			            );
			    }

			    const newBean =
			    {
			        ...filterBean,

			        [filterType]:
			            newIds
			    };
				
			    onChange(newBean);
			};

			const handleOptionChangeExclude =
			    function(e)
			{
			    const itemId =
			        parseInt(e.target.id);

			    let newIds =
			        [...excludeIds];

			    if(e.target.checked)
			    {
			        if(!newIds.includes(itemId))
			        {
			            newIds.push(itemId);
			        }
			    }
			    else
			    {
			        newIds =
			            newIds.filter(
			                function(id)
			                {
			                    return id !== itemId;
			                }
			            );
			    }

			    const newBean =
			    {
			        ...filterBean,

			        [excludeType]:
			            newIds
			    };

			    onChange(newBean);
			};
			

			const optionDisplayInclude =
			    (options || []).map(
            function(item)
            {
                return (

                    <div
                        key={item.id}
                        style={optionRow}
                    >

                        <input
                            type="checkbox"
                            id={item.id}
                            style={optionCheck}
                            onChange={handleOptionChangeInclude}
                            checked={
                                includeIds.includes(
                                    parseInt(item.id)
                                )
                            }
                        />

                        <div style={optionText}>
                            {item.name}
                        </div>

                    </div>

                );
            }
        );

		const optionDisplayExclude =
		    (options || []).map(
            function(item)
            {
                return (

                    <div
                        key={item.id}
                        style={optionRow}
                    >

                        <input
                            type="checkbox"
                            id={item.id}
                            style={optionCheck}
                            onChange={handleOptionChangeExclude}
                            checked={
                                excludeIds.includes(
                                    parseInt(item.id)
                                )
                            }
                        />

                        <div style={optionText}>
                            {item.name}
                        </div>

                    </div>

                );
            }
        );

    return (

        <div style={thisContainer}>

            <div style={header}>

                <div style={headerTitle}>
                    {title}
                </div>

                <div style={toggleContainer}>

                    <div
                        style={
                            toggleButton(
                                selectedValue === "0"
                            )
                        }
                        onClick={
                            function()
                            {
                                setSelectedValue("0");
                            }
                        }
                    >
                        Include
                    </div>

                    <div
                        style={
                            toggleButton(
                                selectedValue === "1"
                            )
                        }
                        onClick={
                            function()
                            {
                                setSelectedValue("1");
                            }
                        }
                    >
                        Exclude
                    </div>

                </div>

            </div>

            {
                selectedValue === "0"
                &&
                <div style={optionPanel}>
                    {optionDisplayInclude}
                </div>
            }

            {
                selectedValue === "1"
                &&
                <div style={optionPanel}>
                    {optionDisplayExclude}
                </div>
            }

        </div>

    );
}